import React from 'react';
import { useStore } from 'zustand';

import type { IconComponentFunction } from '@motorway/mw-highway-code';
import { Button } from '@motorway/mw-highway-code';

import { CountStore, modalService } from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';
import { ReactComponent as SendEmailIcon } from 'Public/static/images/send-email-icon.svg';
import {
	triggerPurchasesCompleteSellerMessagingButtonClickedEvent,
	triggerPurchasesCompleteSellerMessagingButtonHoveredEvent,
} from 'Services/analytics/events';
import { Tooltip } from 'Storybook/core/Tooltip';

import styles from './ModalTrigger.module.scss';

export const ModalTrigger = () => {
	const { unsentMessagesCount } = useStore(CountStore);

	const onClick = () => {
		modalService.onOpen();
		triggerPurchasesCompleteSellerMessagingButtonClickedEvent(unsentMessagesCount);
	};

	const onHover = () => {
		triggerPurchasesCompleteSellerMessagingButtonHoveredEvent();
	};

	return (
		<div className={styles.modalTrigger} onFocusCapture={(event) => event.stopPropagation()}>
			{unsentMessagesCount && (
				<div className={styles.countWrapper}>
					<span className={styles.count} data-testid="seller-messaging-count">
						{unsentMessagesCount}
					</span>
				</div>
			)}
			<Tooltip content={T.translate('triggerModalLabel')}>
				<Button
					aria-label={`${T.translate('triggerModalLabel')}`}
					icon={SendEmailIcon as IconComponentFunction}
					label={T.translate('label')}
					onClick={onClick}
					onMouseEnter={onHover}
					showLabel={false}
					size="medium"
					type="button"
					variant="secondary"
				/>
			</Tooltip>
		</div>
	);
};
